/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  $(document).on('click', '#add-new-project-links-btn', function() {
    selectizeProjectField($('.company_product_project_links_project_participant_id select').last());
    return selectizeUnitField($('.company_product_project_links_unit select').last());
  });

  root.autocompleteUnit = () => $('.company_product_project_links_unit select').each(function() {
    return selectizeUnitField(this);
  });

  root.selectizeProject = () => $('.company_product_project_links_project_participant_id select').each(function() {
    return selectizeProjectField(this);
  });

  window.selectizeProjectField = function(obj) {
    let existingTaggedProjectsId;
    $(obj).selectize({
      valueField: 'project_participant_id',
      labelField: 'title',
      searchField: 'title',
      create: false,
      loadThrottle: 600,
      items: [$(obj).data("project-participant-id")],
      options: [
        {
          project_participant_id: $(obj).data("project-participant-id"),
          title: $(obj).data("title"),
          location: $(obj).data("location"),
          sectors: $(obj).data("sectors"),
          photo_url: $(obj).data("photo-url")
        }
      ],
      load(query, callback) {
        if (!query.length) {
          return callback();
        }
        return $.ajax({
          url: "/companies/" + $('#company_product_company_id').val() + "/portfolio/auto_complete_search",
          dataType: 'json',
          type: 'get',
          data: {
            q: query,
            selected_prjects: existingTaggedProjectsId()
          },
          success(data) {
            return callback(data);
          }
        });
      }
    });

    const projectSectors = function(sectors) {
      let sectors_pills = "";
      let i = 0;
      const ending_index = sectors.length > 3 ? 3 : sectors.length;
      while (i < ending_index) {
        sectors_pills = sectors_pills + `<span> ${sectors[i]} </span>`;
        i++;
      }

      if (sectors.length > 3) {
        sectors_pills = sectors_pills + `<span> + ${sectors.length - 3} </span>`;
      }

      return sectors_pills;
    };

    $(document).on('click', '#project_link_form .remove_nested_fields', function() {
      if ($(this).closest('.fields').find("select").data("project-participant-id") === null) {
        return $(this).closest('.fields').remove();
      }
    });

    return existingTaggedProjectsId = function() {
      const ids = [];
      $('.company_product_project_links_project_participant_id select').each(function() {
        if ($(this).val() !== "") {
          return ids.push($(this).val());
        }
      });
      return ids;
    };
  };

  window.selectizeUnitField = obj => $(obj).selectize({
    create: true,
    sortField: 'text'
  });

  const category_param = getURLParameter('category');
  if (category_param !== 'null') {
    $('.specific-filters').show();

    if ($('#search_category').length === 0) {
      const input = $("<input>").attr({type: 'hidden', name: 'category', id: 'search_category', value: unescape(category_param)});
      $('#products_search').append($(input));
    }
  }


  $('#company_widget_country_id').selectize({
    sortField: 'text'});

  $('#company_product_category_id').selectize({
    sortField: 'text'});

  $(document).on('click', '#add-new-specification-btn', () => setTimeout((function() {
    apply_selectize_to_aspect_fiels();
    if ($('#add-new-specification-btn').hasClass('locked')) {
      return removeAspectsFields();
    }
  }), 100));

  $(document).on('click', '.delete-quote-item', function(e) {
    e.preventDefault();
    return $(e.currentTarget).parents('.row').remove();
  });

  $(document).on('click', 'a#request-quote-btn', function(e) {
    if ($('#request-quote-modal').length > 0) {
      $('#request-quote-modal').foundation('reveal', 'open');

      if ($('.company_enquiry_quote_request_items_product_id').first().val() === '') {
        $('.company_enquiry_quote_request_items_product_id').first().find('option[value=\'' + $('#request-quote-modal').data('widget-title') + '\']').attr('selected', 'selected');
      }

      $('.company_enquiry_quote_request_items_product_id select').selectize({
        sortField: 'text',
        onChange(value) {
          const current_selected_values = [];
          return $.each($('.company_enquiry_quote_request_items_product_id select.selectized'), function(index, value) {
            if (jQuery.inArray($(value).val(), current_selected_values) === -1) {
              return current_selected_values.push($(value).val());
            } else {
              return alert('This product has already been selected in other select box of this form. Please recheck your selection and try again');
            }
          });
        }
      });

      if ($('#add-new-request-quote-item-btn').data('product-size') === 1) {
        return $('#add-new-request-quote-item-btn').hide();
      }
    } else {
      e.preventDefault();
      return $('#signin-modal').foundation('reveal', 'open');
    }
  });

  $(document).on('click', '#add-new-request-quote-item-btn', function(e) {
    e.preventDefault();

    const newId = new Date().getTime();

    const $row = $('.modal-body .row.cloneable').clone().removeClass('cloneable');
    $row.find('select').prop('name', $row.find('select').prop('name').replace(/\d/g, newId));
    $row.find('input').prop('name', $row.find('input').prop('name').replace(/\d/g, newId)).val('');
    $row.find('.delete').removeClass('hidden');

    $(e.currentTarget).parents('.row').before($row);

    const new_select_box = $('.company_enquiry_quote_request_items_product_id select:not(.selectized)');

    $('.company_enquiry_quote_request_items_product_id select:not(.selectized)').selectize({
      sortField: 'text',
      onChange(value) {
        const current_selected_values = [];
        return $.each($('.company_enquiry_quote_request_items_product_id select.selectized'), function(index, value) {
          if (jQuery.inArray($(value).val(), current_selected_values) === -1) {
            return current_selected_values.push($(value).val());
          } else {
            return alert('This product has already been selected in other select box of this form. Please recheck your selection and try again');
          }
        });
      }
    });

    if ($('.company_enquiry_quote_request_items_product_id select').length === $('#add-new-request-quote-item-btn').data('product-size')) {
      return $('#add-new-request-quote-item-btn').hide();
    }
  });

  $(document).on('click', '#request_quote_form .remove_nested_fields', function() {
    $(this).closest('.fields').remove();
    if ($('.company_enquiry_quote_request_items_product_id select').length < $('#add-new-request-quote-item-btn').data('product-size')) {
      return $('#add-new-request-quote-item-btn').show();
    }
  });

  setTimeout((function() {
    if ($('#approvable_attributes').length > 0) {
      return $.each($('#approvable_attributes .attribute'), function(index, value) {
        const name  = $(this).data('name');
        value = $(this).data('value');
        return add_specification(name, value);
      });
    } else {
      return apply_selectize_to_aspect_fiels();
    }
  }), 500);

  var add_specification = function(name, spec_value) {
    const addLink = $('#add-new-specification-btn');
    return $.each($('.company_widget_products_company_product_aspects_name input'), function(index, value) {
      if ($(this).val() === "") {
        $(this).val(name);
        const value_input = $(this).parent('.company_widget_products_company_product_aspects_name').siblings('.company_widget_products_company_product_aspects_value').find('input');
        value_input.val(spec_value);
        value_input.selectize({
          create: true,
          plugins: ['restore_on_backspace','remove_button','drag_drop']});
        addLink.click();
        return;
      }
    });
  };

  var apply_selectize_to_aspect_fiels = () => $('.company_widget_products_company_product_aspects_value input.aspects_value').selectize({
    create: true,
    plugins: ['restore_on_backspace','remove_button','drag_drop']});

  $(window).bind("popstate", function() {
    if (window.location.pathname === '/products') {
      return $.getScript(document.location.href);
    }
  });

  $(document).on('click', '#products-sort-by a', () => $.ajax(window.location.pathname, {
    type: 'GET',
    data: $('#products_search').serialize() + "&order_by=" + $('#products-sort-by a.selected').data('value'),
    dataType: 'script',
    beforeSend(xhr) {
      return appendLoader();
    }
  }
  ));

  $(document).on('click', '#save_product', function() {
    if ($('#uploaded_photos li.product-photo').length === 0) {
      $('#product-photos-errors').show();
      $('#product-photos-errors .max').hide();
      $('#product-photos-errors .min').show();
      if($('#company_widget_form').parsley().isValid()) {
        $('body').scrollTo('#uploaded_photos');
        $(this).removeClass('processing');
        return false;
      }
    }
  });

  autoCompleteTextFields();

  $(document).on('change', 'input[name=\'photos[]\']', function() {
    if ($('input[name=\'photos[]\']:checked').length > 0) {
      $('#product-photos-errors').hide();
    }
    if ($('input[name=\'photos[]\']:checked').length > 5) {
      $('#exceed_maximum_number_of_photos').foundation('reveal', 'open');
      $(this).prop('checked', false);
    }
  });

  if ($('#product-categories li.active').length > 0) {
    $('#product-categories li.active').closest('ul.level-5').show();
    $('#product-categories li.active').closest('ul.level-4').show();
    $('#product-categories li.active').closest('ul.level-3').show();
    $('#product-categories li.active').closest('ul.level-2').show();
    $('#product-categories li.active').closest('ul.level-1').show();
  }

  $(document).on('click', '#product-detail .pt-close', function() {
    if ($(this).data('referer') === '') {
      return window.location = ($(this).data('path'));
    } else {
      return window.history.back();
    }
  });

  $(document).on('change', '.company_widget_photos_image input[type=file]', function(e) {

    if (($('#uploaded_photos li.product-photo').length + $(e.target.files).length) > 5) {
      $('#product-photos-errors').show();
      $('#product-photos-errors .max').show();
      $('#product-photos-errors .min').hide();
      return;
    }

    let height = $('li.product-photo .photo-container').width();

    $(e.target.files).each(function(key, value) {
      if (key === 0) {
        $('.photo-container .add-files').remove();
        $('.uploaded-photo-placeholder').siblings('.edit-controls').removeClass('hide');
        $('.uploaded-photo-placeholder').closest('li').attr('data-filename',value.name);
        $('.uploaded-photo-placeholder').closest('li').addClass('product-photo');
        $('.uploaded-photo-placeholder').siblings('.edit-controls').find('.main-photo-r').val(value.name);

        height = $('.uploaded-photo-placeholder').closest('.photo-container').width();

        loadImage(value, (function(img) {
          $('.uploaded-photo-placeholder').replaceWith(img);
        })
        );

        $('li.product-photo .photo-container').css('background','white');
        return setTimeout((function() {
          $('li.product-photo .photo-container img').css('max-height', height);
          return $('li.product-photo .photo-container img').show();
        }), 50);
      } else {
        const class_name = Math.random().toString(36).substring(7);
        const new_li =
          '<li class="product-photo photo-uploading-placeholder-' + class_name + '" data-filename="' + value.name + `">
<div class="photo-container" style="background:white;height:` + height + `px;">
<div class="img-placeholder"></div>
<div class="edit-controls">
<input class="main-photo-r" id="mainphoto_" name="mainphoto" type="radio" value="` + value.name + `">
<label class="product-main-photo">MAIN</label>
<a class="set-as-cover-btn">
<span class="text">Set as main</span>
</a>
<div class="edit">
<a class="delete-product-photo" href="#"><i class="pti pt-delete"></i>
</a>
</div>
</div>
</div>
</li>`;

        $(new_li).insertBefore($('#upload-photo-btn'));
        $('#uploaded_photos').append(new_li);

        loadImage(value, (function(img) {
          $('.photo-uploading-placeholder-' + class_name).find('.img-placeholder').replaceWith(img);
        })
        );

        $('li.product-photo .photo-container img').css('max-height', height);
        $('li.product-photo .photo-container img').show();

        return setTimeout((function() {
          $('li.product-photo .photo-container img').css('max-height', height);
          $('li.product-photo .photo-container img').show();

          return $.each($('li.product-photo .photo-container img'), function(key, value) {
            if (parseInt($(value).attr('width')) > parseInt($(value).attr('height'))) {
              return $(value).css('width', height);
            }
        });
        }), 200);
      }
    });

    $('#product-photos-errors').hide();
    if ($('#uploaded_photos li.product-photo').length < 5) {
      setTimeout((function() {
        $('.dropper a.add_nested_fields').click();
        height = $('#uploaded_photos li .photo-container').width();
        $('li.product-photo .photo-container img').css('max-height', height);
        $('li.product-photo .photo-container').height(height);
        return $('#uploaded_photos .upload-product-photo').height(height);
      }), 100);
    }

    if ($('#uploaded_photos .fields input.main-photo-r[type=radio]:checked').length === 0) {
      const first_radio_box = $('input.main-photo-r[type=radio]').first();
      first_radio_box.prop("checked", true);
      return first_radio_box.closest('li').addClass('main-photo');
    }
  });
  if ($('#company_widget_form.edit-form').length > 0) {
    if ($('#uploaded_photos li.product-photo').length < 5) {
      $('#upload-photos-form-content a.add_nested_fields').click();
    }
  }

  $(document).on('change', '#company_widget_documents_attributes_1_document, #product_document', function() {
    let filename = $(this).val();
    const lastIndex = filename.lastIndexOf('\\');
    if (lastIndex >= 0) {
      filename = filename.substring(lastIndex + 1);
    }
    return $('#company_widget_specification_filename').html(filename);
  });

  $(document).on('change', '#company_widget_documents_attributes_0_document, #product_document', function() {
    let filename = $(this).val();
    const lastIndex = filename.lastIndexOf('\\');
    if (lastIndex >= 0) {
      filename = filename.substring(lastIndex + 1);
    }
    return $('#company_widget_datasheet_filename').html(filename);
  });

  $(document).on('change', '#company_widget_documents_attributes_0_document, #company_widget_documents_attributes_1_document', function() {
    $(this).closest('.fields').find('a.button.delete').removeClass('hide');
    $(this).closest('.file-input-btn').find("#company_widget_documents_attributes_1__destroy").val('false');
    return $(this).closest('.file-input-btn').find("#company_widget_documents_attributes_0__destroy").val('false');
  });

  $(document).on('click', ".upload-section .fields a.button.delete", function() {
    $(this).closest('.file-input-btn').find('.filename').html('');
    $(this).closest('.file-input-btn').find('i.pt-view').hide();
    return $(this).addClass('hide');
  });

  $(document).on('click', 'a.delete-product-photo', function() {
    let new_value;
    const li = $(this).closest('li');
    if (li.hasClass('uploaded')) {
      li.data('photoid');
      new_value = $('#delete_photo_ids').val() + ',' + li.data('photoid');
      $('#delete_photo_ids').val(new_value);
    } else {
      new_value = $('#delete_photo_names').val() + ',' + li.data('filename');
      $('#delete_photo_names').val(new_value);
    }
    $('.dropper .deleted_photos').append(li.contents());
    li.remove();
    if ($('#uploaded_photos li.product-photo').length < 5) {
      if ($('.uploaded-photo-placeholder').length === 0) {
        setTimeout((function() {
          $('.dropper a.add_nested_fields').click();
          const height = $('#uploaded_photos li .photo-container').width();
          $('li.product-photo .photo-container img').css('max-height', height);
          $('li.product-photo .photo-container').height(height);
          return $('#uploaded_photos .upload-product-photo').height(height);
        }), 100);
      }
    }
    return false;
  });

  if ($('#company_widget_description').length > 0) {
    $('#company_widget_description').simplyCountable({
      counter: '#description_counter',
      maxCount: 2000,
      countDirection: 'up',
      strictMax: true
    });
  }

  $(document).on('click', 'a.set-as-cover-btn', function() {
    $('.main-photo').removeClass('main-photo');
    $('input.main-photo-r[type=radio]').prop("checked", false);
    $(this).closest('li').addClass('main-photo');
    return $(this).siblings("input.main-photo-r").prop("checked", true);
  });

  if ($('#products-search-result').length > 0) {
    $.each($('#products-search-result .vcard-info h4 a'), function(index, value) {
      if ($(this).parent().height() < $(this).height()) {
        $(this).parent().css('height', '3.68rem');
      }
      return $(this).parent().siblings('.manufacturer').css('opacity', 1);
    });
  }


  $('ul.photos-bxslider').each(function(index){
    if ($(this).find('li.bxslider-image').length > 1) {
      $(this).bxSlider({
        captions: false,
        pagerCustom: '#photos-bx-pager',
        nextText: '',
        prevText: '',
        infiniteLoop: true,
        adaptiveHeight: false,
        hideControlOnEnd: true,
        onSliderLoad() {
          setTimeout(( function() {
            if ($('#photos-bx-pager').length > 0) {
              $('.details-image-container .bx-controls').css('opacity', 1);
            }
            if ($(".bxslider-image").length > 0) {
              return $('.details-image-container .photos-bxslider').css('opacity', 1);
            }
          }), 1000);
          return $.cloudinary.responsive();
        }
      });
    }
  })

  return $(document).on('click', "form .toggle-more-options-btn", function() {
    const button = $(this);
    const hiddenContent = $(this).parent().siblings('.collapseable');
    if (hiddenContent.is(':visible')) {
      hiddenContent.slideUp('fast');
      return button.removeClass('show-less');
    } else {
      hiddenContent.slideDown('fast');
      return button.addClass('show-less');
    }
  });
});

$(document).on('click', "form#company_widget_form input[type='checkbox']", function() {
  const value = $(this).val();
  if (value.toLowerCase().indexOf("_other") >= 0) {
    const arr = value.split('_');
    const id = $("#" + arr[0] + "_other");
    if ($(this).is(':checked')) {
      id.show();
      return id.addClass('required');
    } else {
      id.hide();
      return id.removeClass('required');
    }
  }
});

$('select[id^=product_details_select_]').on('change', function() {
  alert('aSD');
  const value = $(this).val();
  let id = $("#" + value);

  if (value.toLowerCase().indexOf("_other") >= 0) {
    id.show();
    return id.addClass('required');
  } else {
    const arr = value.split('_');
    id = $("#" + arr[0] + "_other");
    id.hide();
    return id.removeClass('required');
  }
});

$(document).on('change', '#company_product_category_id', function() {
  if ($('#company_product_category_id').val() !== '') {
    return $.ajax({
      url: "/categories/" + $('#company_product_category_id').val() + "/attributes",
      type: 'GET',
      dataType: 'script',
      data: {
        'product_id': $('#product_id').val()
      },
      beforeSend(xhr) {
        return appendLoader('#product_details');
      },
      complete(xhr) {
        destroyLoader('#product_details');
        autoCompleteTextFields();
        return productMultiSelect();
      }
    });
  } else {
    return $("#product_details").empty();
  }
});

var autoCompleteTextFields = function() {
  const textFields = $("[id$='textfield']");
  return jQuery.each(textFields, function(index, value) {
    return $(this).autocomplete({
      source:  $(this).data('autocomplete-source'),
      minLength: 0}).on('focus', function(event) {
        return $(this).autocomplete('search', '');
    });
  });
};

$(document).on('change', '#company_widget_specification:not(.multiple-upload)', function() {
  $('#company_widget_form.data-parsley-validate').parsley().destroy();
  $(this).attr('data-parsley-value', $(this).val());
  return $('#company_widget_form.data-parsley-validate').parsley();
});

this.removeAspectsFields = () => $('.aspects-row').remove();
